module.exports = __webpack_public_path__ + "static/media/BG.be591412.png";